import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { PaywallCheckoutPreview } from "@circle-react/types";
import { Fragment } from "react";

import { CheckoutFormSection } from "../../../../CheckoutFormSection";
import { DEFAULT_FULL_PREVIEW_VARIANT } from "../../constants";
import { componentsByVariants } from "./variants";

export interface FuturePaymentsPreviewProps {
  className?: string;
  preview: PaywallCheckoutPreview;
  variant?: keyof typeof DEFAULT_FULL_PREVIEW_VARIANT;
}

export const FuturePaymentsPreview = ({
  preview,
  className,
  variant = DEFAULT_FULL_PREVIEW_VARIANT.default,
}: FuturePaymentsPreviewProps) => {
  if (preview.paywall_price.price_type === "onetime") {
    return null;
  }

  const listOfComponents = (componentsByVariants[variant] ||
    componentsByVariants[DEFAULT_FULL_PREVIEW_VARIANT.default])[
    preview.paywall_price.price_type
  ];

  return (
    <CheckoutFormSection className={classNames("gap-y-2 border-t", className)}>
      {/* eslint-disable-next-line sonarjs/no-uniq-key, sonarjs/pseudo-random -- Disabled for plugin version update. Fix when possible. */}
      <Fragment key={Math.random()}>
        {listOfComponents.map(([component, getOptions]) =>
          component({ preview, options: getOptions(preview) || {} }),
        )}
      </Fragment>
    </CheckoutFormSection>
  );
};
